import { Checkbox } from "@/components/ui/checkbox";

export const TermsConsent = ({ accepted, onAcceptedChange }) => (
  <div className="flex items-start gap-2.5" data-testid="terms-consent">
    <Checkbox
      id="terms-consent-checkbox"
      checked={accepted}
      onCheckedChange={(v) => onAcceptedChange(v === true)}
      className="mt-0.5"
      data-testid="terms-consent-checkbox"
    />
    <label htmlFor="terms-consent-checkbox" className="text-sm text-muted-foreground leading-snug cursor-pointer">
      I agree to the{" "}
      <a href="/terms" target="_blank" rel="noopener noreferrer" className="text-primary font-semibold hover:underline" data-testid="terms-consent-terms-link">Terms and Conditions</a>
      {" "}and{" "}
      <a href="/privacy" target="_blank" rel="noopener noreferrer" className="text-primary font-semibold hover:underline" data-testid="terms-consent-privacy-link">Privacy Policy</a>
    </label>
  </div>
);
